import React from "react";
import classNames from "classnames";
import { useMatch } from "react-router-dom";

const SideMenuItem: React.FC<{
  icon: string;
  title: string;
  url: string;
  condensed: boolean;
  disabled?: true;
}> = ({ icon, title, url, condensed, disabled }) => {
  const isActive = useMatch(url) != null;
  let iconSvg = (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M8.61692 3.00854H17.4208C20.6657 3.00854 22.4725 4.79875 22.4725 7.86622V18.2554C22.4725 21.3732 20.6657 23.1232 17.4208 23.1232H8.61692C5.42352 23.1232 3.56421 21.3732 3.56421 18.2554V7.86622C3.56421 4.79875 5.42352 3.00854 8.61692 3.00854ZM8.90054 7.69525V7.68519H12.0404C12.4931 7.68519 12.8608 8.0372 12.8608 8.46866C12.8608 8.91218 12.4931 9.26419 12.0404 9.26419H8.90054C8.44779 9.26419 8.08118 8.91218 8.08118 8.47972C8.08118 8.04726 8.44779 7.69525 8.90054 7.69525ZM8.90054 13.8101H17.1361C17.5878 13.8101 17.9555 13.4581 17.9555 13.0256C17.9555 12.5932 17.5878 12.2401 17.1361 12.2401H8.90054C8.44779 12.2401 8.08118 12.5932 8.08118 13.0256C8.08118 13.4581 8.44779 13.8101 8.90054 13.8101ZM8.90054 18.4063H17.1361C17.5553 18.3661 17.8715 18.0231 17.8715 17.6218C17.8715 17.2095 17.5553 16.8675 17.1361 16.8273H8.90054C8.5854 16.7971 8.28077 16.9379 8.1127 17.1994C7.94462 17.4508 7.94462 17.7827 8.1127 18.0442C8.28077 18.2957 8.5854 18.4465 8.90054 18.4063Z"
      />
    </svg>
  );

  switch (icon) {
    case "dashboard":
      iconSvg = (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M4.35067 1.83331H7.58984C8.94109 1.83331 10.024 2.88748 10.024 4.1809V7.30581C10.024 8.60748 8.94109 9.65248 7.58984 9.65248H4.35067C3.009 9.65248 1.9165 8.60748 1.9165 7.30581V4.1809C1.9165 2.88748 3.009 1.83331 4.35067 1.83331ZM4.35067 12.3472H7.58984C8.94109 12.3472 10.024 13.3931 10.024 14.6948V17.8197C10.024 19.1122 8.94109 20.1664 7.58984 20.1664H4.35067C3.009 20.1664 1.9165 19.1122 1.9165 17.8197V14.6948C1.9165 13.3931 3.009 12.3472 4.35067 12.3472ZM18.6491 1.83331H15.4099C14.0587 1.83331 12.9758 2.88748 12.9758 4.1809V7.30581C12.9758 8.60748 14.0587 9.65248 15.4099 9.65248H18.6491C19.9908 9.65248 21.0833 8.60748 21.0833 7.30581V4.1809C21.0833 2.88748 19.9908 1.83331 18.6491 1.83331ZM15.4099 12.3472H18.6491C19.9908 12.3472 21.0833 13.3931 21.0833 14.6948V17.8197C21.0833 19.1122 19.9908 20.1664 18.6491 20.1664H15.4099C14.0587 20.1664 12.9758 19.1122 12.9758 17.8197V14.6948C12.9758 13.3931 14.0587 12.3472 15.4099 12.3472Z"
          />
        </svg>
      );
      break;
    case "notifications":
      iconSvg = (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M20.0638 9.77223C20.0638 11.0354 20.4125 11.7799 21.1798 12.6378C21.7613 13.2699 21.9472 14.0812 21.9472 14.9615C21.9472 15.8407 21.6454 16.6754 21.041 17.353C20.2496 18.1654 19.1335 18.684 17.9945 18.7742C16.344 18.9089 14.6923 19.0223 13.0188 19.0223C11.3442 19.0223 9.6936 18.9545 8.04302 18.7742C6.90296 18.684 5.78692 18.1654 4.9966 17.353C4.39212 16.6754 4.08936 15.8407 4.08936 14.9615C4.08936 14.0812 4.27623 13.2699 4.8567 12.6378C5.64806 11.7799 5.97379 11.0354 5.97379 9.77223V9.34376C5.97379 7.65216 6.41437 6.54603 7.32161 5.46321C8.67047 3.88404 10.8326 2.93695 12.9718 2.93695H13.0658C15.2509 2.93695 17.483 3.92963 18.8089 5.57666C19.6691 6.6372 20.0638 7.69673 20.0638 9.34376V9.77223ZM9.94427 21.1013C9.94427 20.5948 10.4297 20.3629 10.8787 20.2636C11.4038 20.1572 14.6037 20.1572 15.1288 20.2636C15.5778 20.3629 16.0632 20.5948 16.0632 21.1013C16.0371 21.5834 15.7417 22.0109 15.3335 22.2824C14.8041 22.6774 14.183 22.9276 13.5336 23.0178C13.1744 23.0623 12.8216 23.0633 12.475 23.0178C11.8245 22.9276 11.2033 22.6774 10.6751 22.2814C10.2658 22.0109 9.97037 21.5834 9.94427 21.1013Z"
          />
        </svg>
      );
      break;
    case "calendar":
      iconSvg = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M17.6518 3.09108L17.6528 3.845C20.5465 4.06213 22.4579 5.94994 22.461 8.845L22.4724 17.3191C22.4766 20.4755 20.4054 22.4176 17.0855 22.4226L8.97605 22.4327C5.67688 22.4367 3.57977 20.4483 3.57562 17.2829L3.56422 8.90833C3.56007 5.99417 5.40411 4.11138 8.29776 3.85706L8.29672 3.10314C8.29568 2.66084 8.63794 2.32811 9.09428 2.32811C9.55063 2.3271 9.89289 2.65883 9.89392 3.10113L9.89496 3.80479L16.0556 3.79675L16.0546 3.09309C16.0535 2.65079 16.3958 2.31906 16.8521 2.31806C17.2981 2.31705 17.6507 2.64878 17.6518 3.09108ZM5.16246 9.21894L20.8649 9.19884V8.84701C20.8203 6.68577 19.6877 5.55187 17.6549 5.38299L17.6559 6.15702C17.6559 6.58927 17.3043 6.93205 16.8584 6.93205C16.402 6.93305 16.0587 6.59128 16.0587 6.15903L16.0577 5.3448L9.89704 5.35284L9.89807 6.16607C9.89807 6.59932 9.55685 6.9411 9.10051 6.9411C8.64416 6.9421 8.30087 6.60133 8.30087 6.16808L8.29983 5.39405C6.27739 5.58806 5.15831 6.72598 5.16142 8.90632L5.16246 9.21894ZM16.4217 13.7877V13.7988C16.4321 14.2612 16.8262 14.612 17.3043 14.6019C17.7711 14.5909 18.1434 14.2079 18.133 13.7455C18.1112 13.3032 17.7368 12.9423 17.2712 12.9433C16.7941 12.9534 16.4207 13.3253 16.4217 13.7877ZM17.2784 18.3012C16.8013 18.2911 16.4165 17.9101 16.4155 17.4477C16.4051 16.9853 16.7878 16.6023 17.2649 16.5913H17.2753C17.7628 16.5913 18.1579 16.9723 18.1579 17.4447C18.159 17.9172 17.7648 18.3002 17.2784 18.3012ZM12.1487 13.8038C12.1694 14.2662 12.5646 14.6271 13.0417 14.607C13.5084 14.5858 13.8807 14.2039 13.86 13.7415C13.8486 13.2891 13.4648 12.9373 12.9981 12.9383C12.521 12.9584 12.1476 13.3414 12.1487 13.8038ZM13.0458 18.2559C12.5687 18.276 12.1746 17.9152 12.1528 17.4528C12.1528 16.9904 12.5252 16.6084 13.0023 16.5873C13.469 16.5863 13.8538 16.9381 13.8641 17.3894C13.8859 17.8528 13.5125 18.2348 13.0458 18.2559ZM7.87564 13.839C7.89638 14.3014 8.29153 14.6633 8.76862 14.6421C9.23534 14.622 9.60767 14.239 9.58589 13.7766C9.57552 13.3243 9.19178 12.9725 8.72402 12.9735C8.24694 12.9936 7.8746 13.3766 7.87564 13.839ZM8.77277 18.261C8.29568 18.2821 7.90157 17.9202 7.87979 17.4578C7.87875 16.9954 8.25212 16.6124 8.72921 16.5923C9.19593 16.5913 9.58071 16.9431 9.59108 17.3955C9.61286 17.8579 9.24052 18.2409 8.77277 18.261Z"
          />
        </svg>
      );
      break;
    case "notification-feed":
      iconSvg = (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M8.61692 3.00854H17.4208C20.6657 3.00854 22.4725 4.79875 22.4725 7.86622V18.2554C22.4725 21.3732 20.6657 23.1232 17.4208 23.1232H8.61692C5.42352 23.1232 3.56421 21.3732 3.56421 18.2554V7.86622C3.56421 4.79875 5.42352 3.00854 8.61692 3.00854ZM8.90054 7.69525V7.68519H12.0404C12.4931 7.68519 12.8608 8.0372 12.8608 8.46866C12.8608 8.91218 12.4931 9.26419 12.0404 9.26419H8.90054C8.44779 9.26419 8.08118 8.91218 8.08118 8.47972C8.08118 8.04726 8.44779 7.69525 8.90054 7.69525ZM8.90054 13.8101H17.1361C17.5878 13.8101 17.9555 13.4581 17.9555 13.0256C17.9555 12.5932 17.5878 12.2401 17.1361 12.2401H8.90054C8.44779 12.2401 8.08118 12.5932 8.08118 13.0256C8.08118 13.4581 8.44779 13.8101 8.90054 13.8101ZM8.90054 18.4063H17.1361C17.5553 18.3661 17.8715 18.0231 17.8715 17.6218C17.8715 17.2095 17.5553 16.8675 17.1361 16.8273H8.90054C8.5854 16.7971 8.28077 16.9379 8.1127 17.1994C7.94462 17.4508 7.94462 17.7827 8.1127 18.0442C8.28077 18.2957 8.5854 18.4465 8.90054 18.4063Z"
          />
        </svg>
      );
      break;
    case "history":
      iconSvg = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 0C16.2996 0 21 4.70039 21 10.5C21 16.2996 16.2996 21 10.5 21C8.27285 21 6.20156 20.3027 4.49941 19.1174C3.90469 18.6662 3.75867 17.8828 4.17539 17.2881C4.58965 16.6934 5.40586 16.5498 6.00059 16.9641C7.27617 17.8541 8.82656 18.375 10.5 18.375C14.8477 18.375 18.375 14.8477 18.375 10.5C18.375 6.11543 14.8477 2.625 10.5 2.625C8.28926 2.625 6.35742 3.5052 4.93008 4.93008L6.19336 6.19336C6.8127 6.8127 6.37383 7.875 5.5002 7.875H0.984375C0.440918 7.875 0 7.43613 0 6.89062V2.37645C0 1.49953 1.06025 1.06025 1.68041 1.68041L3.07535 3.07535C4.9752 1.17674 7.6002 0 10.4631 0H10.5ZM10.5 5.25C11.0455 5.25 11.4844 5.68887 11.4844 6.23438V10.0939L14.1135 12.7559C14.5318 13.1414 14.5318 13.7648 14.1135 14.1135C13.7648 14.5318 13.1414 14.5318 12.7559 14.1135L9.80273 11.1604C9.61816 11.0127 9.51562 10.7625 9.51562 10.5V6.23438C9.51562 5.68887 9.95449 5.25 10.5 5.25Z"
            fill-rule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      );
      break;
    case "trade":
      iconSvg = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.37858 3.49841C4.14652 3.49841 3.92396 3.5906 3.75986 3.75469C3.59577 3.91879 3.50358 4.14135 3.50358 4.37341L3.50358 14.5147L1.49983 12.5022C1.33506 12.3374 1.11159 12.2448 0.87858 12.2448C0.645566 12.2448 0.422096 12.3374 0.25733 12.5022C0.0925645 12.6669 1.73609e-09 12.8904 0 13.1234C-1.73609e-09 13.3564 0.0925645 13.5799 0.25733 13.7447L3.75733 17.2447C3.88038 17.3661 4.03663 17.4483 4.20637 17.481C4.37611 17.5137 4.55173 17.4954 4.71108 17.4284C4.87087 17.3628 5.00766 17.2513 5.1042 17.108C5.20074 16.9648 5.25272 16.7962 5.25358 16.6234L5.25358 4.37341C5.25358 4.14135 5.16139 3.91879 4.9973 3.75469C4.8332 3.5906 4.61064 3.49841 4.37858 3.49841ZM7.54608 0.0684128C7.38629 0.134056 7.2495 0.245529 7.15296 0.388784C7.05642 0.53204 7.00444 0.700666 7.00358 0.873413L7.00358 13.1234C7.00358 13.3555 7.09577 13.578 7.25986 13.7421C7.42396 13.9062 7.64652 13.9984 7.87858 13.9984C8.11064 13.9984 8.3332 13.9062 8.4973 13.7421C8.66139 13.578 8.75358 13.3555 8.75358 13.1234L8.75358 2.98216L10.7573 4.99466C10.8387 5.07667 10.9354 5.14177 11.0421 5.18619C11.1487 5.23062 11.2631 5.25349 11.3786 5.25349C11.4941 5.25349 11.6085 5.23062 11.7151 5.18619C11.8217 5.14177 11.9185 5.07667 11.9998 4.99466C12.0818 4.91332 12.1469 4.81654 12.1914 4.70992C12.2358 4.60329 12.2587 4.48892 12.2587 4.37341C12.2587 4.2579 12.2358 4.14354 12.1914 4.03691C12.1469 3.93028 12.0818 3.83351 11.9998 3.75216L8.49983 0.252165C8.37679 0.130751 8.22053 0.0485039 8.05079 0.0158024C7.88105 -0.016901 7.70543 0.00140572 7.54608 0.0684128Z"
            fill-rule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      );
      break;
    case "messages":
      iconSvg = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M18.4595 5.05131C18.4595 3.71369 19.594 2.6275 20.9911 2.6275C22.3882 2.6275 23.5227 3.71369 23.5227 5.05131C23.5227 6.38894 22.3882 7.47512 20.9911 7.47512C19.594 7.47512 18.4595 6.38894 18.4595 5.05131ZM14.4151 15.4599L17.451 11.7096L17.4089 11.7297C17.577 11.5084 17.6085 11.2268 17.493 10.9754C17.3785 10.7239 17.1253 10.553 16.8532 10.5328C16.5686 10.5027 16.286 10.6234 16.1169 10.8446L13.5758 13.9926L10.665 11.8001C10.4864 11.6693 10.2763 11.618 10.0662 11.6392C9.85718 11.6693 9.6681 11.7789 9.541 11.9399L6.43269 15.8129L6.36861 15.9034C6.19003 16.2243 6.27407 16.6366 6.58921 16.8589C6.73627 16.9494 6.89384 17.0098 7.07242 17.0098C7.31507 17.0198 7.54513 16.8981 7.69219 16.708L10.3288 13.4585L13.3226 15.6118L13.4172 15.6711C13.7533 15.8421 14.1735 15.7626 14.4151 15.4599ZM16.6421 4.418C16.6001 4.66944 16.5791 4.92087 16.5791 5.1723C16.5791 7.4352 18.4909 9.26462 20.8439 9.26462C21.1065 9.26462 21.3587 9.23545 21.6213 9.19522V17.3105C21.6213 20.7209 19.5204 22.7424 15.9488 22.7424H8.18696C4.61435 22.7424 2.51343 20.7209 2.51343 17.3105V9.86906C2.51343 6.44958 4.61435 4.418 8.18696 4.418H16.6421Z"
          />
        </svg>
      );
      break;
    case "settings":
      iconSvg = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clipRule="evenodd"
            d="M21.8445 13.8929C22.2202 14.0839 22.5101 14.3857 22.714 14.6874C23.1113 15.3109 23.079 16.0753 22.6926 16.7491L21.9411 17.956C21.5439 18.5997 20.8032 19.002 20.041 19.002C19.6652 19.002 19.2466 18.9014 18.903 18.7002C18.6239 18.5293 18.3019 18.4689 17.9583 18.4689C16.8955 18.4689 16.0045 19.3037 15.9723 20.2994C15.9723 21.4559 14.9847 22.3611 13.7501 22.3611H12.2901C11.0448 22.3611 10.0572 21.4559 10.0572 20.2994C10.0357 19.3037 9.1447 18.4689 8.08192 18.4689C7.72765 18.4689 7.4056 18.5293 7.13721 18.7002C6.79369 18.9014 6.36428 19.002 5.99928 19.002C5.22634 19.002 4.48561 18.5997 4.08841 17.956L3.34767 16.7491C2.95047 16.0954 2.929 15.3109 3.3262 14.6874C3.49797 14.3857 3.82002 14.0839 4.18502 13.8929C4.48561 13.752 4.67884 13.5207 4.86134 13.2492C5.39811 12.3843 5.07605 11.2478 4.16355 10.7349C3.10076 10.1616 2.75724 8.88431 3.36914 7.88864L4.08841 6.70188C4.71105 5.7062 6.04222 5.3542 7.11574 5.93752C8.04971 6.42027 9.26279 6.09844 9.81029 5.24357C9.98205 4.96196 10.0787 4.66024 10.0572 4.35852C10.0357 3.96629 10.1538 3.59417 10.3578 3.29245C10.755 2.6689 11.4743 2.26661 12.2579 2.24649H13.7716C14.566 2.24649 15.2853 2.6689 15.6825 3.29245C15.8757 3.59417 16.0045 3.96629 15.9723 4.35852C15.9508 4.66024 16.0475 4.96196 16.2192 5.24357C16.7667 6.09844 17.9798 6.42027 18.9245 5.93752C19.9873 5.3542 21.3292 5.7062 21.9411 6.70188L22.6604 7.88864C23.283 8.88431 22.9395 10.1616 21.866 10.7349C20.9535 11.2478 20.6314 12.3843 21.1789 13.2492C21.3507 13.5207 21.5439 13.752 21.8445 13.8929ZM9.98205 12.3139C9.98205 13.8929 11.3454 15.15 13.0309 15.15C14.7163 15.15 16.0475 13.8929 16.0475 12.3139C16.0475 10.7349 14.7163 9.46764 13.0309 9.46764C11.3454 9.46764 9.98205 10.7349 9.98205 12.3139Z"
          />
        </svg>
      );
      break;
  }
  return (
    <div
      className={classNames(
        "side-menu-item py-5",
        { "px-8": condensed },
        { "px-7": !condensed },
        { active: isActive },
        { "cursor-not-allowed": disabled }
      )}
    >
      {!disabled && (
        <a href={url} className="z-10 flex">
          <div className="z-10 flex">
            <div
              className={classNames(
                "icon",
                { "text-gold": isActive },
                { "text-gray-light40": !isActive }
              )}
            >
              {iconSvg}
            </div>
            {!condensed && (
              <div
                className={classNames(
                  "side-menu-title text-gray-light50 font-semibold ml-5",
                  { "text-gold": isActive }
                )}
              >
                {title}
              </div>
            )}
          </div>
        </a>
      )}
      {disabled && (
        <div className={classNames(
          "icon z-10 flex bg-gray"
        )}>
          <div
            className={classNames(
              "icon text-gray-300"
            )}
          >
            {iconSvg}
          </div>
          {!condensed && (
            <div
              className={classNames(
                "side-menu-title font-semibold ml-5 text-gray-300"
              )}
            >
              {title}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SideMenuItem;
